import { Injectable } from '@angular/core';
import { DataService } from '../common/data.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private _data: DataService) { }

  /*******************************Service Methods*************************************/
  AddLocationMaster = (data: any): any => {

    return this._data.PostData('LocationMaster/SaveLocationMaster', data);
  }

  GetAllLocationMasterList = (data: any): any => {
    return this._data.PostData('LocationMaster/GetAllLocationMasterList', data);
  }

  GetLocationMasterDataByID = (ID: string): any => {
    return this._data.GetDataById('LocationMaster/GetLocationMasterByID', ID);
  }
  GetLocationMasterDataByLocationID = (ID: string): any => {
    return this._data.GetDataById('LocationMaster/GetLocationMasterByLocationID', ID);
  }
  ExportData = (data: any): any => {
    return this._data.DownloadFileWithPost('LocationMaster/ExportToExcel', data);
}
  /**********************************END*********************************************/
}
